module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_1_null@2x.a446ab71.png";